module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back_to_home":"Zurück zur Homepage"},"en":{"back_to_home":"Back to homepage"},"es":{"back_to_home":"Volver a la página de inicio"},"fr":{"back_to_home":"Retour à la page d\u0027accueil"},"it":{"back_to_home":"Torna alla home page"},"ja":{"back_to_home":"トップに戻る"},"pt":{"back_to_home":"Voltar para a página inicial"}}')
  delete Component.options._Ctor
}
